export const getStyled = (theme) => ({
  main: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'scroll',
    ...theme.custom.scrollbarStyles,
  },
  pinIcon: {
    zIndex: 999,
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'scale(0.7)',
  },
  avatar: {
    transform: 'scale(1.2)',
  },
  cardHeader: {
    width: '380px',
    backgroundColor: theme.custom.colors.momentsHeader,
    color: '#FFF',
  },
  cardHeaderPending: {
    width: '380px',
    backgroundColor: theme.custom.colors.momentsHeader,
    color: '#FFF',
  },
  changeWrap: {
    margin: theme.spacing(0.5),
  },
  card: {
    width: '380px',
    height: '73.5vh',
    marginTop: '3px',
    borderRadius: 1,
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    ...theme.custom.scrollbarStyles,
    borderTop: '2px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: theme.custom.colors.backgroundMessage,
    color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#FFF',
  },
  pending: {
    color: '#fdd835',
    fontSize: '14px',
    marginLeft: '8px',
    transform: 'scale(1.2) translateY(10%)',
  },
  connectionTag: {
    background: 'green',
    color: '#FFF',
    marginRight: '3px',
    padding: '1px 3px',
    fontWeight: 'bold',
    borderRadius: 1.5,
    fontSize: '0.6em',
  },
  lastMessageTime: {
    textAlign: 'right',
    position: 'relative',
    marginRight: '1px',
    color: theme.palette.mode === 'light' ? '#666666' : '#bdbdbd',
  },

  lastMessageTimeUnread: {
    textAlign: 'right',
    position: 'relative',
    color: '#4caf50',
    fontWeight: 'bold',
    marginRight: '1px',
  },
});
